import gql from 'graphql-tag';

export const AppQuery = gql`
    query {
        systemData
        translations
    }
`;
